import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png";
import collegeimg from "../assets/img/RCCimg.jpg";
import hsimg from "../assets/img/BethuneImg.jpg";
import scImg from "../assets/img/hciImg.jpg";

export const Education = () => {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 1000, min: 500 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 1000, min: 500 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 524, min: 200 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
};

return (
    <section className="education" id="education">

  <h1 className="heading"><i className="fas fa-graduation-cap"></i> 📚📖 <span>Education</span></h1>
  <p>   </p>

    <p className="qoute">Education is the passport to the future, for tomorrow belongs to those who prepare for it today.</p>

    <div className="box-container">

    <div className="box">
        <div className="image">
        <img draggable="false" src={collegeimg} alt="College Img"/>
        </div>
        <div className="content">
        <h3>RCC Institute Of Information Technology</h3>
        <p>Btech in Computer Science and Engineering</p>
        <h4>2021-2025 | Pursuing</h4>
        </div>
    </div>

    <div className="box">
      <div className="image">
      <img draggable="false" src={hsimg} alt="School Img2"/>
      </div>
      <div className="content">
      <h3>Bethune Collegiate School</h3>
      <p>Heigher Secondary Education</p>
      <h4>2019-2021 | Completed</h4>
      <p> </p>
      </div>
    </div>

    <div className="box">
      <div className="image">
      <img draggable="false" src={scImg} alt="School Img1"/>
      </div>
      <div className="content">
      <h3>Holy Child Institute</h3>
      <p>Secondary Education</p>
      <h4>2007-2019 | Completed</h4>
      <p> </p>
      </div>
    </div>

</div>
<p>  </p>
</section>
  )
}